import React, { useEffect, useState } from 'react'
import { useNavigate } from 'react-router-dom'
import {
  Avatar,
  Button,
  CircularProgress,
  Grid,
  useMediaQuery
} from '@mui/material'
import AppButton from '../../commonComponents/AppButton'
import { ENV } from '../../ENV'
import { theme } from '../../utils/AppColors'
import AppIcon from '../../commonComponents/AppIcon'
import { TextBold, TextRegular } from '../../commonComponents/TextStyling'
import appassets from '../../utils/appassets'

export default function AccountCreated () {
  const navigate = useNavigate()
  const matches = useMediaQuery(theme.breakpoints.down('sm')) // Detects small screens

  return (
    <Grid item>
      <Grid
        container
        spacing={1}
        style={{
          backgroundImage: `url(./images/background-login.svg)`,
          padding: '0px',
          display: 'flex',
          backgroundSize: 'cover',
          justifyContent: 'center',
          backgroundRepeat: 'no-repeat',
          alignItems: 'center'
        }}
      >
        <div
          style={{
            alignItems: 'center',
            justifyContent: 'center',
            display: 'flex',
            flexDirection: 'column',
            width: '520px',
            margin: '0 auto'
          }}
        >
          {/* <CircularProgress /> */}
          <Avatar
            src={`${appassets.checkGIF}`}
            style={{ width: '250px', height: '230px' }}
          />

          <TextBold
            style={{
              fontSize: '35px',
              textAlign: 'center',
              margin: '10px 0'
            }}
          >
            Your Account has been Sucessfully Created!
          </TextBold>
          <TextRegular>
            You're one step away from reaching top talent. Let's post your first
            job!
          </TextRegular>

          <br />
          <br />
          <Button
          style={{textTransform:'none'}}
            variant='contained'
            onClick={() => navigate('/employer/postnewjob')}
          >
            Post Your First Free Jobs
          </Button>
        </div>
      </Grid>
    </Grid>
  )
}
